import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Paper, Box, Typography, Button,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import '../TargetSearchComponent';
import { COMPANY_POP_KBN, TARGET_SEARCH_DISP_ITEM } from '../../../../common/const';
import styles from '../style.module.css';
import TargetPopSearchCompanyComponent from '../TargetPopSearchCompanyComponent';
import {
  setCompanyPopFlg,
  setCompanyPopBtn,
  setCustomerCompanyAddCondition, // 表示用
  setSupplierCompanyAddCondition, // 表示用
  setTopCompanyAddCondition, // 表示用
} from '../../../actions/TargetAction';

class RelatedCompanyParts extends Component {
  componentDidMount = async () => {
    const {
      setCompanyPopFlgAct,
      setCompanyPopBtnAct,
    } = this.props;
    setCompanyPopFlgAct(false);
    setCompanyPopBtnAct('');
  }

  /**
 *企業選択ポップアップを画面に表示する。
 */
  showCompanyPop = (buttonId) => {
    const {
      setCompanyPopFlgAct,
      setCompanyPopBtnAct,
      customerCompanyDisplayCondition,
      supplierCompanyDisplayCondition,
      topCompanyDisplayCondition,
      setCustomerCompanyAddConditionAct,
      setSupplierCompanyAddConditionAct,
      setTopCompanyAddConditionAct,
    } = this.props;

    if (buttonId === COMPANY_POP_KBN.CUSTOMER) {
      setCustomerCompanyAddConditionAct(customerCompanyDisplayCondition);
    } else if (buttonId === COMPANY_POP_KBN.SUPPLIER) {
      setSupplierCompanyAddConditionAct(supplierCompanyDisplayCondition);
    } else {
      setTopCompanyAddConditionAct(topCompanyDisplayCondition);
    }
    setCompanyPopFlgAct(true);
    setCompanyPopBtnAct(buttonId);
  };

  render() {
    const {
      customerCompanyCondition,
      supplierCompanyCondition,
      topCompanyCondition,
      companyPopFlg,
      targetingDispItems,
    } = this.props;

    // 販売先、仕入先の表示・非表示設定
    let dispHanbaisakiFlg = false;
    let dispSiresakiFlg = false;
    if (targetingDispItems) {
      targetingDispItems.search_option_list.forEach((label) => {
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.HANBAISAKI) {
          dispHanbaisakiFlg = true;
        }
        if (label.item_name === TARGET_SEARCH_DISP_ITEM.SIRESAKI) {
          dispSiresakiFlg = true;
        }
      });
    }

    return (
      <Box className={`${styles.parts}`}>
        <Paper elevation={0} className={`${styles.sectionBox}`}>
          <Box className={`${styles.alignItemsCenter} ${styles.displayFlex} ${styles.marginBottomTitle}`}>
            <Box className={`${styles.sectionTitleIcon} ${styles.marginRightHalf}`} />
            <Typography variant="h6" component="div" className={`${styles.sectionTitle}`}>関連企業</Typography>
          </Box>
          {dispHanbaisakiFlg && (
            <Box className={`${styles.marginBottom2}`}>
              <Box className={`${styles.displayFlex}`}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>販売先</Typography>
              </Box>
              <Box className={`${styles.marginTopHalf} ${styles.displayFlex}`}>
                <Button
                  variant="contained"
                  className="tertiary"
                  endIcon={<OpenInNewIcon />}
                  onClick={() => this.showCompanyPop(COMPANY_POP_KBN.CUSTOMER)}
                >
                  販売先を選択する
                </Button>
                {customerCompanyCondition
                  && customerCompanyCondition.length > 0
                  && (
                    <Typography className={`${styles.countLabel}`} component="span">{`≫${customerCompanyCondition.length}件の条件を設定中`}</Typography>
                  )}
              </Box>
            </Box>
          )}
          {dispSiresakiFlg && (
            <Box className={`${styles.marginBottom2}`}>
              <Box className={`${styles.displayFlex}`}>
                <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>仕入先</Typography>
              </Box>
              <Box className={`${styles.marginTopHalf} ${styles.displayFlex}`}>
                <Button
                  variant="contained"
                  className="tertiary"
                  endIcon={<OpenInNewIcon />}
                  onClick={() => this.showCompanyPop(COMPANY_POP_KBN.SUPPLIER)}
                >
                  仕入先を選択する
                </Button>
                {supplierCompanyCondition
                  && supplierCompanyCondition.length > 0
                  && (
                    <Typography className={`${styles.countLabel}`} component="span">{`≫${supplierCompanyCondition.length}件の条件を設定中`}</Typography>
                  )}
              </Box>
            </Box>
          )}
          <Box>
            <Box className={`${styles.displayFlex}`}>
              <Typography variant="subtitle1" component="div" className={`${styles.sectionSubTitle}`}>国内最上位親会社</Typography>
            </Box>
            <Box className={`${styles.marginTopHalf} ${styles.displayFlex}`}>
              <Button
                variant="contained"
                className="tertiary"
                endIcon={<OpenInNewIcon />}
                onClick={() => this.showCompanyPop(COMPANY_POP_KBN.TOPCOMPANY)}
              >
                国内最上位親会社を選択する
              </Button>
              {topCompanyCondition
                && topCompanyCondition.length > 0
                && (
                  <Typography className={`${styles.countLabel}`} component="span">{`≫${topCompanyCondition.length}件の条件を設定中`}</Typography>
                )}
            </Box>
          </Box>
        </Paper>
        {companyPopFlg && (
          <TargetPopSearchCompanyComponent />
        )}
      </Box>
    );
  }
}

export default connect(
  (state) => ({
    customerCompanyCondition: state.target.customerCompanyCondition,
    supplierCompanyCondition: state.target.supplierCompanyCondition,
    topCompanyCondition: state.target.topCompanyCondition,
    companyPopFlg: state.target.companyPopFlg,
    companyPopBtn: state.target.companyPopBtn,
    customerCompanyDisplayCondition: state.target.customerCompanyDisplayCondition,
    supplierCompanyDisplayCondition: state.target.supplierCompanyDisplayCondition,
    topCompanyDisplayCondition: state.target.topCompanyDisplayCondition,
    targetingDispItems: state.target.targetingDispItems,
  }),
  (dispatch) => ({
    setCompanyPopFlgAct: (bool) => dispatch(setCompanyPopFlg(bool)),
    setCompanyPopBtnAct: (bool) => dispatch(setCompanyPopBtn(bool)),
    setCustomerCompanyAddConditionAct: (obj) => dispatch(
      setCustomerCompanyAddCondition(obj),
    ),
    setSupplierCompanyAddConditionAct: (obj) => dispatch(
      setSupplierCompanyAddCondition(obj),
    ),
    setTopCompanyAddConditionAct: (obj) => dispatch(setTopCompanyAddCondition(obj)),
  }),
)(RelatedCompanyParts);
